import elementLocale from 'element-ui/lib/locale'
import moment from 'moment'
import {LOCALE_SERVICES_MAP} from "../config/locale"

let translateInstance = null

class Translate {

  #onNoTranslateCb = this.#noTranslateCollector
  #locale = null
  #lang = null

  setLocalization (locale) {
    this.#locale = locale
    if (!LOCALE_SERVICES_MAP.hasOwnProperty(this.#locale)) {
      throw Error('Unknown locale: ' + this.#locale + ', not found in localesMap')
    }
    // set lang
    console.log('Locale', locale)
    this.#lang = LOCALE_SERVICES_MAP[this.#locale].main
    elementLocale.use(LOCALE_SERVICES_MAP[this.#locale].elementUI)
    moment.locale(LOCALE_SERVICES_MAP[this.#locale].moment)
  }

  /**
   * @param {String}key
   * @returns {String}
   */
  translate (key = '') {
    if (this.#lang.hasOwnProperty(key)) {
      return this.#lang[key]
    }
    return this.#onNoTranslateCb(key)
  }

  /**
   * @param {Function}cb
   */
  onNoTranslate (cb) {
    this.#onNoTranslateCb = cb
  }

  // console.log(window.MISSING_TRANSLATE)
  #noTranslateCollector (key) {
    if (!window.MISSING_TRANSLATE) {
      window.MISSING_TRANSLATE = {}
    }
    window.MISSING_TRANSLATE[key] = key
    // console.warn('MISSING_TRANSLATE', window.MISSING_TRANSLATE)
    return key
  }

  /**
   * @returns {Translate}
   */
  static getInstance () {
    if (translateInstance === null) {
      translateInstance = new Translate()
    }
    return translateInstance
  }
}

/**
 * @returns {Translate}
 */
export function getTranslateInstance () {
  return Translate.getInstance()
}

export function InstallTranslate (Vue) {
  const instance = Translate.getInstance()
  Vue.prototype.$translate = instance.translate.bind(instance)
}
